type EnvConfig = {
  API_ROOT: string;
  DOCUMENT_BASEURL: string;
  REMOTE_CONFIG: string;
  REMOTE_CONFIG_TIMEOUT: string;
};

export const envConfig: EnvConfig = {
  API_ROOT: import.meta.env.VITE_PUBLIC_PRODUCTION_BASE_URL as string,
  DOCUMENT_BASEURL: import.meta.env
    .VITE_PUBLIC_PRODUCTION_DOCUMENT_BASEURL as string,
  REMOTE_CONFIG: import.meta.env.VITE_PUBLIC_REMOTE_CONFIG as string,
  REMOTE_CONFIG_TIMEOUT: import.meta.env
    .VITE_PUBLIC_REMOTE_CONFIG_TIMEOUT as string,
};
